module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18132/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp2.svg"